import clsx from 'clsx';

import AppDatePicker from 'components/DatePicker';
import Tab from 'components/Tab';
import styles from './styles.module.scss';

const DESCRIPTION = `
با توجه به اجرایی شدن قانون سامانه مودیان در خصوص ارسال فاکتور رسمی
در آن سامانه; احراز و تطابق اطلاعات شناسایی (حقیقی و حقوقی) در پنل
کاربری با اطلاعات پرونده مالیاتی الزامی است. در صورت مغایرت اطلاعات،
عواقب عدم ارسال فاکتور رسمی بر عهده مشتری است.
`;

function UserInfoForm({
  formData,
  selectedForm,
  handleChange,
  handleFormSelection,
  showMandatoryBadge = false,
}) {
  const selectedFormTabIndex = selectedForm === 'person' ? 0 : 1;
  const isFormNonMandatory = showMandatoryBadge && selectedForm === 'person';

  const handleChangeBirthDate = (value) => {
    const dateString = value
      ? `${value.year}/${value.month?.number}/${value.day}`
      : '';

    handleChange({
      target: {
        name: 'birthDate',
        value: dateString,
      },
    });
  };

  const renderField = (fieldItem) => {
    const { value } = fieldItem;
    const hasError = !!fieldItem.error;

    if (fieldItem.type === 'datePicker') {
      return (
        <AppDatePicker
          setSelectedDate={handleChangeBirthDate}
          selectedDate={value}
          className={clsx([
            styles.birth_date_picker,
            hasError && styles.has_error,
          ])}
          rangeEnabled={false}
          renderSideMenu={false}
          monthsDisplay={1}
          containerClassName={styles.birth_date_picker__container}
        />
      );
    }

    return (
      <input
        value={value}
        type={fieldItem.type}
        placeholder={fieldItem.placeholder}
        name={fieldItem.id}
        onChange={handleChange}
        className={clsx(hasError && 'has-error')}
        disabled={fieldItem.disabled}
      />
    );
  };

  const renderTab = (tabFields) => {
    const fields = tabFields
      .filter((item) => !item.isPreview)
      .map((item) => (
        <div key={item.name} className={styles.input_wrapper}>
          <label>{item.label}</label>
          {renderField(item)}
          {item.error && <div className={styles.error_msg}>{item.error}</div>}
        </div>
      ));

    return fields;
  };

  const handleChangeTab = (tabId) => handleFormSelection(tabId);

  const TAB_ITEMS = [
    {
      id: 'person',
      title: 'حقیقی',
      content: renderTab(formData.person.fields),
    },
    {
      id: 'company',
      title: 'حقوقی',
      content: renderTab(formData.company.fields),
    },
  ];

  const renderTabContent = TAB_ITEMS.map((item) => (
    <div label={item.title} key={item.id} tabId={item.id}>
      <form className={styles.form_wrapper}>{item.content}</form>
    </div>
  ));

  return (
    <div className={styles.info_form_modal}>
      <div className={styles.header}>
        <div className={styles.description}>
          <p>{DESCRIPTION}</p>
          <br />
          <p>
            <b className={styles.notice_text}>
              {' '}
              توجه {isFormNonMandatory && 1} :{' '}
            </b>
            در صورتی که هنگام ذخیره اطلاعات با خطای{' '}
            <i>ناهماهنگی شماره تلفن و کدملی مواجه شدید</i> میتوانید از قسمت
            پروفایل کابری منوی پروفایل (بالا سمت چپ) شماره خود را براساس کدملی
            خود ویرایش نمایید
          </p>

          {isFormNonMandatory && (
            <p>
              <b className={styles.notice_text}>
                {' '}
                توجه {isFormNonMandatory && 2} :{' '}
              </b>
              توجه کنید که پر کردن اطلاعات برای <b>اشخاص حقیقی</b> اختیاری بوده
              و شما میتوانید با فشردن دکمه <i>ادامه فرآیند خرید</i> از این مرحله
              گذر کرده و به قسمت پرداخت بروید.
            </p>
          )}
        </div>
      </div>
      <Tab
        contentClass={styles.tab_content}
        tabButtonClass={styles.tab_button}
        tabsClass={styles.tab}
        onTabChange={handleChangeTab}
        defaultActiveTab={selectedFormTabIndex}
      >
        {renderTabContent}
      </Tab>
    </div>
  );
}

export default UserInfoForm;
